
/**
 * @type {{
*  icon: String
*  title: String
*  current: Boolean
*  set_current: Function
*  on_click: Function
* }}
*/
let HeaderTabItem;


/**
* @type [HeaderTabItem]
*/
let HeaderTabsItems;

class HeaderTabController 
{
   /**
    * Initialize controller and pass data to create tabs.
    * @param {HeaderTabsItems} items 
    */
   constructor(items)
   {
       /**
        * @type HeaderTabsItems
       */
       this.items = items ?? [];
       this.ControllerUpdater = function(){};
       this.on_change = function(){};
       this.set_items(this.items);
   }
   /**
    * 
    * @param {HeaderTabItem} item 
    */
   push(item)
   {
       this.items.push(item);
       this.set_items(this.items);
       this.ControllerUpdater(item);
   }
   set_items(items){
       let app = this;
       items = items ?? [];
       let current_item = null;
       this.items = items.filter((item, key)=>{
           if(item?.hidden === true){
                return false;
           }
           /**
            * create an empty event on undefined 
            * and set current to false on undefined.
            */
           item.on_click = item.on_click ?? function(){}
           item.current = item.current ?? false;
           item.is_disabled = item.is_disabled ?? false;
            
           /**
            * create event set current to parse active tab.
            */
           item.set_current = function(key){

               let results = item.on_click();

               if(results === 'preventDefault'){
                   return;
               }

               app.items = app.items.filter(( item )=>{
                   item.current = false;
                   return item;
               })
               
               app.items[key].current = true;
               app.items = app.items;
               current_item = item;
               app.ControllerUpdater(item);
           }
           return item;
       })

       app.ControllerUpdater(current_item);
   }
}


export {HeaderTabController, HeaderTabsItems, HeaderTabItem}